var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 937 158"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M556.8 1.4c-42.7 0-77.4 34.7-77.4 77.6s34.7 77.6 77.4 77.6 77.4-34.7 77.4-77.6-34.6-77.6-77.4-77.6m0 130.3c-29.1 0-52.6-23.6-52.6-52.7s23.5-52.7 52.6-52.7 52.6 23.6 52.6 52.7-23.5 52.7-52.6 52.7M72.6 100.8 27.1 1.4H1.5l58.3 127.3 12.8 27.9 12.8-27.9L143.7 1.4h-25.5zM313.2 86.1l-43-84.7H246l54.8 107.9v47.3h24.8v-47.4L380.4 1.4h-24.1zM910.1 1.4h-25.3L843.1 91 801 1.4h-25.3l-25.4 155.2h25.4l18.8-115.2 36 76.7 10.3 21.9h4.8l10.2-21.9 35.6-76.4 18.7 114.9h25.4z",
    className: "logo_svg__st0"
  })));
};
export default SvgLogo;